export const userKeys = {
  base: ['self'],
};
